// CATALOGO DE LIGAS.
//
// Cada liga traz seus times reais e o SEU formato -- numero de rodadas,
// conferencias, quantos vao aos playoffs e em quantos jogos se decide cada
// serie. O motor de temporada le tudo daqui: nao ha "82" nem "Leste" escrito
// em lugar nenhum do codigo.
//
// Os TIMES sao reais; os ATLETAS sao ficticios, gerados por semente. Um elenco
// inventado envelhece, evolui e e negociado sem depender de nenhuma base de
// dados de pessoas reais -- e cada carreira nova sorteia elencos diferentes.
//
// `strength` (-1 a +1) e a expectativa daquele clube dentro da propria liga, e
// `level` e o nivel medio da liga em pontos de overall. E por isso que um
// elenco do NBB e mais fraco e mais barato que um da NBA sem nenhuma regra
// especial: sai da mesma curva, num patamar diferente.

export const LEAGUES = {
  nba: {
    id: 'nba',
    name: 'NBA',
    country: 'Estados Unidos',
    flagCode: 'US',
    blurb: '30 times, 82 rodadas, playoffs em melhor de 7.',
    level: 78,
    talentSpread: 1,
    // Regra de tempo da liga. A NBA joga quartos de 12 minutos; a FIBA (e o
    // NBB) joga de 10. Sao 8 minutos a menos de jogo, e por isso o placar de
    // um jogo do NBB e muito mais baixo que o de um jogo da NBA -- nao e o
    // ritmo, e o regulamento.
    rules: { quarterSeconds: 12 * 60, overtimeSeconds: 5 * 60 },
    regularRounds: 82,
    conferences: ['Leste', 'Oeste'],
    playoffTeamsPerConference: 8,
    // Vitorias necessarias por fase.
    seriesWins: { 1: 4, 2: 4, 3: 4, 4: 4 },
    roundNames: {
      1: 'Primeira fase',
      2: 'Semifinal de conferencia',
      3: 'Final de conferencia',
      4: 'Final',
    },
    // Draft com loteria, 2 rodadas -- como e feito hoje.
    draft: { rounds: 2, lottery: true },
    tradeDeadlineRound: 55,
    economy: {
      // Escala de dinheiro da liga. Um atleta de overall 70 na NBA nao vale o
      // mesmo que um de 70 no NBB: nao e so o nivel do atleta que muda, e o
      // mercado inteiro em volta dele.
      moneyScale: 1,
      salaryCap: 140,
      luxuryTaxRate: 1.5,
      minRoster: 12,
      maxRoster: 15,
      startingCash: 119,
      revenueBase: 38,
      revenueWin: 46,
    },
    /* ⚠️ `strength` vem da CAMPANHA REAL da temporada passada, normalizada de
       -1 a 1 -- a mesma fonte e a mesma conta do NBB. Chutar esses valores
       fazia o catalogo discordar dos elencos: o clube que o jogo dizia ser
       forte entrava em quadra com o elenco de quem terminou em ultimo. Para
       atualizar, rode `node scripts/coletar-nba.mjs` -- ele imprime estas
       linhas prontas, da mesma coleta que gerou rosters-nba.js. */
    teams: [
      // Leste
      { name: 'Atlanta Hawks', conference: 'Leste', strength: 0.24 },
      { name: 'Boston Celtics', conference: 'Leste', strength: 0.66 },
      { name: 'Brooklyn Nets', conference: 'Leste', strength: -0.87 },
      { name: 'Charlotte Hornets', conference: 'Leste', strength: 0.15 },
      { name: 'Chicago Bulls', conference: 'Leste', strength: -0.4 },
      { name: 'Cleveland Cavaliers', conference: 'Leste', strength: 0.49 },
      { name: 'Detroit Pistons', conference: 'Leste', strength: 0.83 },
      { name: 'Indiana Pacers', conference: 'Leste', strength: -0.91 },
      { name: 'Miami Heat', conference: 'Leste', strength: 0.11 },
      { name: 'Milwaukee Bucks', conference: 'Leste', strength: -0.36 },
      { name: 'New York Knicks', conference: 'Leste', strength: 0.53 },
      { name: 'Orlando Magic', conference: 'Leste', strength: 0.19 },
      { name: 'Philadelphia 76ers', conference: 'Leste', strength: 0.19 },
      { name: 'Toronto Raptors', conference: 'Leste', strength: 0.24 },
      { name: 'Washington Wizards', conference: 'Leste', strength: -1 },
      // Oeste
      { name: 'Dallas Mavericks', conference: 'Oeste', strength: -0.62 },
      { name: 'Denver Nuggets', conference: 'Oeste', strength: 0.58 },
      { name: 'Golden State Warriors', conference: 'Oeste', strength: -0.15 },
      { name: 'Houston Rockets', conference: 'Oeste', strength: 0.49 },
      { name: 'Los Angeles Clippers', conference: 'Oeste', strength: 0.06 },
      { name: 'Los Angeles Lakers', conference: 'Oeste', strength: 0.53 },
      { name: 'Memphis Grizzlies', conference: 'Oeste', strength: -0.66 },
      { name: 'Minnesota Timberwolves', conference: 'Oeste', strength: 0.36 },
      { name: 'New Orleans Pelicans', conference: 'Oeste', strength: -0.62 },
      { name: 'Oklahoma City Thunder', conference: 'Oeste', strength: 1 },
      { name: 'Phoenix Suns', conference: 'Oeste', strength: 0.19 },
      { name: 'Portland Trail Blazers', conference: 'Oeste', strength: 0.06 },
      { name: 'Sacramento Kings', conference: 'Oeste', strength: -0.79 },
      { name: 'San Antonio Spurs', conference: 'Oeste', strength: 0.92 },
      { name: 'Utah Jazz', conference: 'Oeste', strength: -0.79 },
    ],
  },

  nbb: {
    id: 'nbb',
    name: 'NBB',
    country: 'Brasil',
    flagCode: 'BR',
    blurb: '18 times, turno e returno, playoffs em melhor de 5.',
    level: 68,
    // Liga menor tem topo mais baixo: o astro do NBB nao e um astro da NBA.
    talentSpread: 0.66,
    // Alem do periodo de 10 minutos, o NBB joga mais DEVAGAR: ~78 posses por
    // time contra ~99 da NBA. E o ritmo, nao a eficiencia, que explica o
    // placar mais baixo -- pontos por 100 posses sao parecidos nas duas ligas.
    rules: { quarterSeconds: 10 * 60, overtimeSeconds: 5 * 60, secondsPerPossession: 15.4 },
    // Turno e returno: 2 x 17 adversarios.
    regularRounds: 34,
    // Liga unica, sem conferencia -- o motor trata isso com uma "conferencia"
    // so, e a tela nem mostra o seletor.
    conferences: null,
    playoffTeams: 8,
    // Quartas e semifinal em melhor de 5; final em melhor de 7.
    seriesWins: { 1: 3, 2: 3, 3: 4 },
    roundNames: { 1: 'Quartas de final', 2: 'Semifinal', 3: 'Final' },
    // O NBB tem draft de novos atletas, sem loteria: ordem inversa pura.
    draft: { rounds: 2, lottery: false },
    tradeDeadlineRound: 20,
    economy: {
      // Escala brasileira: o orcamento de um clube do NBB nao e o de uma
      // franquia da NBA, e isso muda como se joga -- aqui cada contratacao
      // pesa muito mais.
      moneyScale: 0.075,
      salaryCap: 11,
      luxuryTaxRate: 1.2,
      minRoster: 11,
      maxRoster: 14,
      startingCash: 9,
      revenueBase: 3.4,
      revenueWin: 4.2,
    },
    /* ⚠️ `strength` vem da CAMPANHA REAL da temporada passada (o aproveitamento
       na tabela da LNB), normalizada de -1 a 1 -- o mesmo numero que
       scripts/coletar-nbb.mjs usa para deslocar o overall dos elencos.
       Chutar esses valores fazia o catalogo discordar dos elencos: os 18
       clubes ficaram com media entre 74,3 e 76,5, ou seja, uma liga inteira
       sem time forte nem fraco. Para atualizar, rode o script -- ele imprime
       estas linhas prontas. */
    teams: [
      { name: 'Flamengo', conference: 'NBB', strength: 0.69 },
      { name: 'Franca', conference: 'NBB', strength: 1 },
      { name: 'Minas', conference: 'NBB', strength: 0.77 },
      { name: 'Paulistano', conference: 'NBB', strength: 0.39 },
      { name: 'Bauru', conference: 'NBB', strength: 0.15 },
      { name: 'Pinheiros', conference: 'NBB', strength: 0.85 },
      { name: 'Corinthians', conference: 'NBB', strength: 0.62 },
      { name: 'Mogi', conference: 'NBB', strength: 0.15 },
      { name: 'Brasilia', conference: 'NBB', strength: 0.69 },
      { name: 'Caxias do Sul', conference: 'NBB', strength: -0.15 },
      { name: 'Unifacisa', conference: 'NBB', strength: 0.08 },
      { name: 'Pato Basquete', conference: 'NBB', strength: -0.92 },
      { name: 'Sao Jose', conference: 'NBB', strength: 0.23 },
      { name: 'Botafogo', conference: 'NBB', strength: -0.69 },
      { name: 'Cruzeiro', conference: 'NBB', strength: -0.46 },
      { name: 'Basquete Cearense', conference: 'NBB', strength: -0.92 },
      { name: 'Osasco', conference: 'NBB', strength: -0.92 },
      { name: 'Uniao Corinthians', conference: 'NBB', strength: 0 },
    ],
  },
};

export const LEAGUE_LIST = Object.values(LEAGUES);

export function getLeagueConfig(id) {
  return LEAGUES[id] || LEAGUES.nba;
}

/** Conferencias reais da liga (liga unica devolve uma pseudo-conferencia). */
export function conferencesOf(config) {
  return config.conferences || [config.teams[0]?.conference || 'Liga'];
}

/** Quantos times entram nos playoffs, no total. */
export function playoffSize(config) {
  return config.conferences
    ? config.playoffTeamsPerConference * config.conferences.length
    : config.playoffTeams;
}

/** Numero de fases de playoff da liga. */
export function playoffRounds(config) {
  return Object.keys(config.seriesWins).length;
}
